export default __webpack_public_path__ + "static/media/by.f0d75f1f.svg";